<template>
  <div class="l-page l-page--abtest-list">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main--flex">
      <div class="l-main-head">
        <h2 class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">A/Bテスト配信結果の一覧</div>
        </h2>

        <a class="c-btn c-btn--blue u-w280" :href="abtestInfo.indexUrl">
          <div class="c-icon c-icon--white u-wh22 c-icon--alpha70">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#abtest" />
            </svg>
          </div>
          <p class="c-btn__text">新しくA/Bテストを始める</p>
        </a>

      </div>
      <div class="l-main-content">
        <div class="p-abtest-result">
          <h2 class="c-title u-w600">
            <div class="c-title__text u-fs18">設定されているテスト一覧</div>
          </h2>
          <div class="p-abtest-result__data" :class="{'is-loading': isLoading, 'is-empty': isEmpty}">
            <loader v-if="isLoading" />
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--abtest">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w140 is-sortable">
                    <span class="c-table__text">配信日時</span>
                    <sort-switch name="deliverDate" :order="sortTargets.deliverDate" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w140 is-sortable">
                    <span class="c-table__text">テスト項目</span>
                    <sort-switch name="abtestType" :order="sortTargets.abtestType" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w220 is-sortable">
                    <span class="c-table__text">テスト名</span>
                    <sort-switch name="abtestName" :order="sortTargets.abtestName" @on-click="onSortButtonClick($event)" />
                  </th>
                </tr>
              </thead>
              <tbody v-if="abtests">
                <abtest-result-item
                  v-for="(abtest,index) in abtests.data"
                  :key="index"
                  :abtest="abtest"
                  :abtest-info="abtestInfo"
                  @delete-click="onDeleteClick"
                  @copy-click="onCopyClick"
                  @show-click="onShowClick"
                />
              </tbody>
            </table>
            <pagination v-if="paginationInfo" :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>
        </div>
      </div>
    </main>

    <!-- モーダル: 削除確認 -->
    <control-modal
      ref="refControlModal"
      classes="c-modal--message-delete"
      title="以下のテストを削除してもよろしいですか?"
      :body="'テスト : ' + currentAbtestName"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active=isDeleteMessage
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModal"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    csrfToken: String,
    abtestInfo: Object,
  },
  data() {
    return {
      sortTargets: {
        deliverDate: -1,
        abtestType: 0,
        abtestName: 0,
        abtestStatus: 0,
        distribution: 0,
        impression: 0,
      },
      abtests: null,
      paginationInfo: null,
      isLoading: false,
      isDeleteMessage: false,
      isEmpty: false,
      isError: false,
      errorMessage: '',
      currentAbtestName: null,
    }
  },
  mounted: function () {
    import('../../funcs/pages/abtest').then(module => {
      module.Abtest();
    });
    this.loadData();
  },
  methods: {
    loadData: function () {
      // ソート情報を抽出
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if (this.sortTargets[workTarget] != 0) {
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      // 情報取得用パラメタ作成
      const params = {
        params: {
          sort: sortTarget,
          order: order,
          page: this.page,
          is_result_page: true,
        }
      };

      // ローダー表示設定
      this.isLoading = true;

      // 配信状況データの取得処理実行
      axios.get('/api/abtest/list', params)
        .then(res => {
          this.abtests = res.data.abtests;
          this.paginationInfo = res.data.abtests;
          setTimeout(() => {
            this.isLoading = false;
            if (res.data.abtests.data.length < 1) this.isEmpty = true;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = 'ABテスト配信結果一覧の取得時にエラーが発生しました'
            this.isLoading = false;
          }, 300);
        });
    },
    onSortButtonClick: function (target) {
      this.currentSortTarget = target;
      if (!this.sortTargets[target] || (this.sortTargets[target] == -1)) {
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if (workTarget != target) {
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },
    onPageClick: function (clickPage) {
      this.page = clickPage;
      this.loadData();
    },
    onDeleteClick: function (abtest) {
      this.isDeleteMessage = true;
      this.currentAbtestId = abtest.abtest_id;
      this.currentAbtestName = abtest.abtest_name;
      // this.$refs.deleteModal.showConfirmModal();
    },
    onCopyClick: function (abtestId) {
      location.href = this.abtestInfo.addUrl + '?type=copy&abtest_id=' + abtestId;
    },
    onShowClick: function (abtestId) {
      location.href = this.abtestInfo.resultUrl + '?abtest_id=' + abtestId;
    },

    // -----------------------------------------------------------------------------------------------------
    // あとでUI調整と合わせて調整をします
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },

    // クリック: 操作モーダルを閉じる処理
    onCloseConrolModal() {
      this.isDeleteMessage = false;
      this.$refs.refControlModal.resetErrorMessage();
    },
    // クリック: 操作モーダルのENTER処理
    onEnterConrolModal() {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refControlModal.showLoader();

      // パラメタ作成
      const params = {
        abtest_id: this.currentAbtestId,
      };

      // 削除処理実行
      axios.post('/api/abtest/delete', params)
        .then(_res => {
          this.$refs.refControlModal.hideLoader();
          this.isDeleteMessage = false;
          this.errorMessage = ''
          this.isLoading = true;
          this.loadData();
        })
        .catch(error => {
          this.$refs.refControlModal.hideLoader();
          this.$refs.refControlModal.showErrorMessage('テストの削除に失敗しました');
          this.handleHttpError(error);
        });
    },
  }
}
</script>
